<template>
    <div class="audio-reader">

        <div class="audioimgtopreader">
            <!-- <img :src="audios!.image" /> -->

            <div class="s-title">
                <p class="common-heading ms-3 mt-5">Client Number: {{ audios!.clientNumber }}</p>
                <!-- <p class="blue-link closable ms-3 mt-3" @click="closetrigger()">Close</p> -->
            </div>
            <div class="s-title">
                <p class="common-heading ms-3">Date and Time: {{ audios!.calldatetime }}</p>
                <!-- <p class="blue-link ms-3 mt-3">Close</p> -->
            </div>
            <!-- <audio ref="audioElement" controls>
                <source :src="audios!.url" @timeupdate="updateTime" type="audio/mpeg" />
            
            </audio> -->
            <audio ref="audioElement" :src="audios!.recordingUrl" @timeupdate="updateTime"></audio>
            <div class="progress">
                <div class="progress-bar" :style="{ width: progress + '%' }" @click="seek($event)" ref="progressBar">
                </div>
            </div>
            <div class="timing">{{ formattedTime }} / {{ formattedDuration == 'NaN:NaN' ? '0:00' : formattedDuration }}
            </div>
            <div class="audioplayer pb-3">
                <div class="audiomenu" @click="skipBackward()">
                    <i class="pi pi-angle-left" />

                </div>
                <div class="audiomenu" @click="playPause()">
                    <i :class="isPlaying ? 'pi pi-pause' : 'pi pi-play'" />

                </div>
                <div class="audiomenu" @click="skipForward()">
                    <i class="pi pi-angle-right" />

                </div>



            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, computed, watch, watchEffect } from 'vue';
import { useHotkey } from 'v-hotkey3';

export default defineComponent({
    props: {
        audios: {
            type: Object
        }
    },
    setup(props) {
        const isPlaying = ref(false);
        const audioElement = ref();
        const progressBar = ref();
        const progress = ref(0);
        const currentTime = ref(0);
        const duration = ref(0);
        let playerbool = ref(true)
        let playPause = () => {
            debugger
            if (isPlaying.value) {
                audioElement.value.pause();
            } else {
                audioElement.value.play();
            }
            isPlaying.value = !isPlaying.value;
        };

        function closetrigger() {
            playerbool.value = true, audioElement.value.pause(),
                props.audios!.id = 0
        }
        useHotkey({
            'ctrl+s': () => {
            },
            'esc': () => {
            },
            'space': {
                keydown() {
                    playPause()
                    // alert('test')
                },
            }
        })
        const skipBackward = () => {
            audioElement.value.currentTime -= 10; // Skip 10 seconds backward
        };

        const skipForward = () => {
            audioElement.value.currentTime += 10; // Skip 10 seconds forward
        };

        const seek = (event) => {
            const progressBarWidth = progressBar.value.offsetWidth;
            const clickedPosition = event.clientX - progressBar.value.getBoundingClientRect().left;
            const seekTime = (clickedPosition / progressBarWidth) * duration.value;
            audioElement.value.currentTime = seekTime;
        };

        const updateTime = () => {
            currentTime.value = audioElement.value.currentTime;
            duration.value = audioElement.value.duration;
            progress.value = (currentTime.value / duration.value) * 100 || 0;
        };

        const formattedTime = computed(() => {
            const minutes = Math.floor(currentTime.value / 60);
            const seconds = Math.floor(currentTime.value % 60);
            return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
        });

        const formattedDuration = computed(() => {
            const minutes = Math.floor(duration.value / 60);
            const seconds = Math.floor(duration.value % 60);
            return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
        });

        onMounted(() => {
            // audioElement.value.addEventListener('timeupdate', updateTime);
            // alert('s')
        });

        watch(
            () => props.audios!.id,
            () => {
                // alert('s')

                if (playerbool.value == true) {
                    playerbool.value = false
                    // audioElement.value.addEventListener('timeupdate', updateTime);
                    // formattedDuration1
                    // formattedTime


                    // audioElement.value.play();
                }
                // audioElement.value.pause();

                // playPause()
                // skipForward()
                // formattedDuration
                // formattedTime

                // updateTime()
                // audioElement.value.play();

            }
        );


        return {
            closetrigger,
            playerbool,
            audioElement,
            isPlaying,
            seek,
            formattedTime,
            formattedDuration,
            updateTime,
            skipBackward,
            playPause,
            skipForward,
            progress
        }
    }

})
</script>

<style lang="scss" scoped>
.audio-reader {
    // position: absolute;
    height: auto;
    padding: 2px;
    // width: 23%;
    // bottom: 0px;
    // right: 23.1%;
    margin: 40px;
    border-radius: 20px;
    background-color: white;

    // background-color: gray;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);

    margin-top: 15px;
    margin-bottom: 15px;
    // position: fixed;
}

.closable {
    cursor: pointer;
}

.audioplayer {
    display: flex;
    align-items: center;
    /* align-content: space-between; */
    justify-content: center;

    .audiomenu {
        display: flex;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        height: 40px;
        width: 40px;
        padding: 10px;
        border-radius: 20px;
        margin: 0px 10px 0px 10px;
        align-items: center;
        align-content: flex-start;
        justify-content: center;

        // i {
        //     align-items: center;
        // }
    }
}

.audioimgtopreader {
    // position: relative;

    img {
        height: 91px;
        width: 100%;
        object-fit: fill;
        border-top-right-radius: 20px;
        border-top-left-radius: 20px;

    }

    .s-title {
        display: flex;
        justify-content: space-between;
        margin: 0px 10px 0px 10px
    }

}

.audio-player {
    text-align: center;
    padding: 20px;
}

.controls {
    margin-top: 10px;
}

.progress {
    width: 100%;
    height: 5px;
    background-color: #ccc;
    margin-top: 10px;
    cursor: pointer;
}

.progress-bar {
    height: 100%;
    align-items: center;
    background-color: #3498db;
}

.timing {
    margin-top: 5px;
    font-size: 12px;
}

@media screen and (max-width: 769px) {

    .audio-reader {
        // position: absolute;
        height: auto;
        padding: 10px;
        width: 90%;
        // bottom: 0px;
        right: 10%;
        left: 10%;

        // border-radius: 20px;
        // background-color: white;

        // // background-color: gray;
        // box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);

        // margin-top: 15px;
        // margin-bottom: 15px;
        // position: fixed;
    }

    .audioimgtopreader {
        position: relative;

        img {
            display: none;

        }

        // .s-title {
        //     display: flex;
        //     justify-content: space-between;
        //     margin: 0px 10px 0px 10px
        // }

    }
}
</style>
